import AdvancedController from "./advanced-controller";
import { gsap } from "gsap";
import Hunt from 'huntjs';


export default class MediaBackgroundController extends AdvancedController {
  static targets = [
    // 'content'
    "backgroundVideo",
  ];

  connect() {
    super.connect();

    new Hunt(this.element, {
      persist: true,
      enter: () => this.playBackgroundVideo(),
      leave: () => this.pauseBackgroundVideo(),
    });
  }

  playBackgroundVideo() {
    if (this.hasBackgroundVideoTarget) {
      this.backgroundVideoTarget.play();
    }
  }

  pauseBackgroundVideo() {
    if (this.hasBackgroundVideoTarget) {
      this.backgroundVideoTarget.pause();
    }
  }
}
